'use client';
import '@mux/mux-player/themes/minimal';
export default 'minimal';
